import styled from '@emotion/styled'

import { BodyM } from '@/components/Typography'
import { CONFIG } from '@/styles/emotion.config'

export const ProductCarouselBackground = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 5rem 0;

  ${CONFIG.media.mobileLg} {
    padding: 2.5rem 0;
  }
`

export const ProductCarouselContainer = styled.div`
  max-width: ${CONFIG.maxWidths.md};
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${CONFIG.media.mobileLg} {
    align-items: center;
    max-width: calc(100vw - 2rem);
  }
`

export const ProductCarouselContent = styled.div`
  width: 54.625rem;

  ${CONFIG.media.mobileLg} {
    max-width: calc(100vw - 2rem);
  }
`

export const ProductCarouselCards = styled.div`
  width: 100%;
  display: flex;
  gap: 1.5rem;
  margin-top: 1.5rem;

  ${CONFIG.media.mobileLg} {
    max-width: 30rem;
  }
`

export const Subtitle = styled(BodyM)`
  margin-top: 1rem;
  margin-bottom: 1.5rem;
`
